import { schema } from 'normalizr';

const labelSchema = new schema.Entity('labels', {});

export default labelSchema;
